// tslint:disable:variable-name

import { schema } from "normalizr";

const UserSchema = new schema.Entity("user");

// C A T E G O R Y

const AccessGroupSchema = new schema.Entity("accessGroup");

const ContactTypeSchema = new schema.Entity("contactType");

const JobStatusSchema = new schema.Entity("jobStatus");

const JobTypeSchema = new schema.Entity("jobType");

const LookupTypeSchema = new schema.Entity("lookupType");

// A C C O U N T  O B J E C T

const MembershipSchema = new schema.Entity("membership", {
    user: UserSchema
});

const NotificationTemplateSchema = new schema.Entity("notificationTemplate");

const DefaultTaskSchema = new schema.Entity("defaultTask");

const AccountStatisticsSchema = new schema.Entity("accountStatistics");

// R E S T R I C T E D  A C C O U N T  O B J E C T
const ReportLayoutSchema = new schema.Entity("reportLayout");

const ContactSchema = new schema.Entity("contact");

const ControlSchema = new schema.Entity("control");
const ControlTypeSchema = new schema.Entity("controlType");

const GroupSchema = new schema.Entity("group", {
    controls: [ControlSchema]
});

const LookupSchema = new schema.Entity("lookup");

const NoteSchema = new schema.Entity("note");

const FileSchema = new schema.Entity("file");

const FormSchema = new schema.Entity("form", {
    groups: [GroupSchema]
});

const FieldSchema = new schema.Entity("field", {

    // @todo workaround https://git.ironcode.io/vas/vas-rest/issues/41
    control: ControlSchema,
    accessGroup: AccessGroupSchema
});

const ReportSchema = new schema.Entity("report");

const TaskSchema = new schema.Entity("task");

const TaskTypeSchema = new schema.Entity("taskType");

// A C C O U N T

const AccountSchema = new schema.Entity("account", {
    accessGroups: [AccessGroupSchema],
    contactTypes: [ContactTypeSchema],
    jobStatuses: [JobStatusSchema],
    jobTypes: [JobTypeSchema],
    taskTypes: [TaskTypeSchema],
    lookupTypes: [LookupTypeSchema],
    memberships: [MembershipSchema],
    accountStatistics: [AccountStatisticsSchema],
    reportLayouts: [ReportLayoutSchema], // @todo confirm if this is available on accounts download
    forms: [FormSchema], // @todo confirm if this is available on accounts download
    owner: UserSchema,
    createdBy: UserSchema,
    modifiedBy: UserSchema
});

const JobSchema = new schema.Entity("job", {
    account: AccountSchema,
    accessGroup: AccessGroupSchema,
    jobType: JobTypeSchema,
    jobStatus: JobStatusSchema,
    createdBy: UserSchema,
    modifiedBy: UserSchema,
    // fields: [FieldSchema],
    files: [FileSchema]
});

const ExternalLookupProviderSchema = new schema.Entity("externalLookupProvider");

const ExternalLookupSchema = new schema.Entity("externalLookup");

const JobStatusSummarySchema = new schema.Entity("jobStatusSummary");

const TransitionSchema = new schema.Entity("transition");

export {
    AccessGroupSchema,
    AccountSchema,
    AccountStatisticsSchema,
    ContactSchema,
    ContactTypeSchema,
    ControlSchema,
    ControlTypeSchema,
    DefaultTaskSchema,
    ExternalLookupProviderSchema,
    ExternalLookupSchema,
    FileSchema,
    FormSchema,
    GroupSchema,
    JobSchema,
    JobStatusSchema,
    JobStatusSummarySchema,
    TaskSchema,
    TaskTypeSchema,
    JobTypeSchema,
    LookupSchema,
    LookupTypeSchema,
    MembershipSchema,
    NoteSchema,
    NotificationTemplateSchema,
    ReportSchema,
    ReportLayoutSchema,
    TransitionSchema,
    UserSchema,
    FieldSchema
};



// WEBPACK FOOTER //
// ./src/vas/api/schema.ts